var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5813 28.2821C11.2782 28.7873 10.623 28.9511 10.1179 28.648C9.61272 28.3449 9.44892 27.6897 9.75201 27.1845L12.0198 23.4048C12.7909 22.1197 14.1798 21.3333 15.6785 21.3333H27.7333C28.9115 21.3333 29.8667 20.3782 29.8667 19.2V4.26667C29.8667 3.08846 28.9115 2.13333 27.7333 2.13333H4.26667C3.08846 2.13333 2.13333 3.08846 2.13333 4.26667V19.2C2.13333 20.3782 3.08846 21.3333 4.26667 21.3333H7.46667C8.05577 21.3333 8.53333 21.8109 8.53333 22.4C8.53333 22.9891 8.05577 23.4667 7.46667 23.4667H4.26667C1.91025 23.4667 0 21.5564 0 19.2V4.26667C0 1.91025 1.91025 0 4.26667 0H27.7333C30.0898 0 32 1.91025 32 4.26667V19.2C32 21.5564 30.0898 23.4667 27.7333 23.4667H15.6785C14.9291 23.4667 14.2347 23.8598 13.8492 24.5024L11.5813 28.2821ZM10.6667 10.6667C10.0776 10.6667 9.6 10.1891 9.6 9.6C9.6 9.0109 10.0776 8.53333 10.6667 8.53333H21.3333C21.9224 8.53333 22.4 9.0109 22.4 9.6C22.4 10.1891 21.9224 10.6667 21.3333 10.6667H10.6667ZM10.6667 14.9333C10.0776 14.9333 9.6 14.4558 9.6 13.8667C9.6 13.2776 10.0776 12.8 10.6667 12.8H21.3333C21.9224 12.8 22.4 13.2776 22.4 13.8667C22.4 14.4558 21.9224 14.9333 21.3333 14.9333H10.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d917741c504d43164018ff4a37b137de.svg";
export { ForwardRef as ReactComponent };